import { render } from "./ChatScreenView.vue?vue&type=template&id=6d21d706&scoped=true"
import script from "./ChatScreenView.vue?vue&type=script&lang=js"
export * from "./ChatScreenView.vue?vue&type=script&lang=js"

import "./ChatScreenView.vue?vue&type=style&index=0&id=6d21d706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d21d706"]])

export default __exports__